import script from "./EstoqueSaldosOrigemAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./EstoqueSaldosOrigemAdministrar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__